import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, useMediaQuery } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { IconCaretRightFilled, IconPhoto } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';
import CustomPagination from '../../../components/pagination/CustomPagination';

function ProductsTable({ products, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage }) {
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {!isMobile && <TableCell></TableCell>}
                            <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.PRODUCT)}</TableCell>
                            {!isMobile && <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.DESCRIPTION)}</TableCell>}
                            {!isMobile && <TableCell style={{ fontWeight: 'bold' }}>{t(StringKeys.PRICE)}</TableCell>}
                            {isMobile && <TableCell></TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {products.map((product) => (
                            <TableRow 
                                key={product.id} 
                                onClick={() => {
                                    !isMobile && navigate(`/products/${product.id}`);
                                }}
                                style={{ cursor: !isMobile ? 'pointer' : 'default' }}
                            >
                                {!isMobile && (
                                    <TableCell>
                                        {product.image_url ? (
                                            <img
                                                src={product.image_url}
                                                alt="Product Image"
                                                style={{ width: '40px', height: '40px', marginRight: '10px' }}
                                            />
                                        ) : (
                                            <IconPhoto size={40} />
                                        )}
                                    </TableCell>
                                )}
                                <TableCell>{product.name}</TableCell>
                                {!isMobile && <TableCell>{product.description}</TableCell>}
                                {!isMobile && <TableCell>${(product.default_price.unit_amount / 100).toFixed(2)}</TableCell>}
                                {isMobile && 
                                    <TableCell sx={{textAlign:"end"}}>
                                        <IconButton
                                            component={Link}
                                            to={`/products/${product.id}`}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <IconCaretRightFilled />
                                        </IconButton>
                                    </TableCell>
                                }
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <CustomPagination
                rowsPerPageOptions={[10, 25, 100, { label: 'All', value: -1 }]}
                component="div"
                count={products.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );
}

export default ProductsTable;
